export const HUD_COLORS = [
    { id: 0, color: '#9e9e9e', label: 'Default' },
    { id: 1, color: '#d1d1d1', label: 'Soft White' },
    { id: 2, color: '#ffffff', label: 'Bright White' },
    { id: 3, color: '#add8e6', label: 'Light Blue' },
    { id: 4, color: '#0041c2', label: 'Dark Blue' },
    { id: 5, color: '#d32ce6', label: 'Purple' },
    { id: 6, color: '#ff4b4b', label: 'Red' },
    { id: 7, color: '#ff8f1c', label: 'Orange' },
    { id: 8, color: '#ffd700', label: 'Yellow' },
    { id: 9, color: '#3fdc46', label: 'Green' },
    { id: 10, color: '#00ffff', label: 'Cyan' },
    { id: 11, color: '#ffb5c6', label: 'Pink' },
    { id: 12, color: '#87ceeb', label: 'Celeste' },
    { id: 13, color: '#d5b996', label: 'Beige' },
]

export const getHudColorHex = (id) =>
    HUD_COLORS.find((c) => c.id === (id || 1))?.color || '#ffffff'

export const getHudColorName = (id) =>
    HUD_COLORS.find((c) => c.id === (id || 1))?.label || 'White'

// --- THEME CONSTANTS ---
export const THEMES = {
    INDIGO: {
        id: 'indigo',
        name: 'Cyber Indigo',
        primary: '#6366f1',
        bg: 'rgba(6, 43, 5, 1)',
        isDark: true
    },
    STEALTH: {
        id: 'stealth',
        name: 'Stealth Gold',
        primary: '#fbbf24',
        bg: 'rgba(43, 30, 5, 1)',
        isDark: true
    },
    MINT: {
        id: 'mint',
        name: 'Crystal Mint',
        primary: '#10b981',
        bg: 'rgba(5, 43, 30, 1)',
        isDark: true
    },
    SOLAR: {
        id: 'solar',
        name: 'Solar Bloom',
        primary: '#f43f5e',
        bg: 'rgba(43, 6, 20, 1)',
        isDark: true
    },
    WHITE: {
        id: 'white',
        name: 'White',
        primary: '#ffffff',
        bg: 'rgba(73, 73, 73, 1)',
        isDark: false
    }

}

export const APP_COLORS = {
    primary: '#6366f1',
    primaryGlow: 'rgba(99, 102, 241, 0.4)',
    bg: '#050208',
    bgSecondary: '#0d0d12',
    border: 'rgba(255, 255, 255, 0.05)',
    text: '#ffffff',
    textMuted: 'rgba(255, 255, 255, 0.5)',
    glass: 'rgba(15, 23, 42, 0.6)'
}

export const COMING_SOON_MODULES = ['graphics', 'video', 'practice', 'custom_scripts', 'binds_special', 'binds_custom', 'radio']
